// extracted by mini-css-extract-plugin
module.exports = {"panel":"styles__panel___39qZK","title":"styles__title___2qZ7D","description":"styles__description___2riEe"};